// extracted by mini-css-extract-plugin
module.exports = {"Container":"KeywordsFilter_Container__35Lqk","Open":"KeywordsFilter_Open__2GmuD","Controls":"KeywordsFilter_Controls__1OpK1"};